<div class="individual-relationship-cell">
  <div class="full-name font-weight-bold line-height-16">{{ fullName }}</div>

  <ul class="list-unstyled m-0 p-0">
    @for (role of roles; track role) {
      <div class="role font-weight-normal line-height-16">{{ role }}</div>
    }
  </ul>

  @if (isResigned) {
    <div class="tag">Past</div>
  }
</div>
